import React from 'react'
import gql from 'graphql-tag'
import { Mutation, MutationFn } from 'react-apollo'
import { ATTACK_EVENT_NOTES_QUERY_NAME } from './query-attack-event-notes'

export const mutationUpdateAttackEventNote = gql`
  mutation UpdateAttackEventNote(
    $organizationId: ID!
    $attackEventUuid: ID!
    $attackEventNoteUuid: ID!
    $note: String!
  ) {
    updateAttackEventNote(
      input: {
        organizationId: $organizationId
        attackEventUuid: $attackEventUuid
        attackEventNoteUuid: $attackEventNoteUuid
        note: $note
      }
    ) {
      _placeholder
    }
  }
`

interface UpdateArgsProps {
  readonly organizationId: string
  readonly attackEventUuid: string
  readonly attackEventNoteUuid: string
  readonly note: string
}

interface ChildProps {
  readonly children: (
    deleteNote: MutationFn<{}, UpdateArgsProps>
  ) => React.ReactNode
}

export function MutationUpdateAttackEventNote({ children }: ChildProps) {
  return (
    <Mutation<{}, UpdateArgsProps>
      mutation={mutationUpdateAttackEventNote}
      refetchQueries={[ATTACK_EVENT_NOTES_QUERY_NAME]}
    >
      {(updateNote) => children(updateNote)}
    </Mutation>
  )
}
